import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FC150, FC151)
// ============================================================

export interface FC151 {
  fc151_01: string;   // 來樣單號 (FK)
  fc151_02: number;   // 項次
  fc151_11: string;   // 檢驗規範代號
  fc151_12: string;   // 允收標準
  fc151_13: string;   // 測試代號
  fc151_21: string;   // 客戶檢驗規範代號
  fc151_22: string;   // 客戶允收標準
}

export interface FC150 {
  fc150_01: string;        // 來樣單號
  fc150_11: string | null; // 來樣日期
  fc150_12: string;        // 客戶代號
  fc150_13: string;        // 部門代號
  fc150_14: string;        // 產品名稱
  fc150_15: string;        // 產品規格
  fc150_16: string;        // 加工別
  fc150_17: number;        // 幅寬-針孔內
  fc150_18: number;        // 幅寬-針孔外
  fc150_19: number;        // 碼重-成品重
  fc150_20: number;        // 米平方重-成品重
  fc150_21: string;        // 備註1
  fc150_22: string;        // 布樣用途
  fc150_23: string;        // 備註2
  fc150_241: string;       // 成分代號
  fc150_242: number;       // 成分比例
  fc150_243: string;       // 成分單位
  fc150_251: string;       // 備註代號
  fc150_252: string;       // 備註內容
  fc150_261: number;       // 樣布需要量
  fc150_262: string;       // 單位
  fc150_27: string;        // 業務員
  fc150_28: number;        // 明細筆數
  fc150_29: string;        // 客戶布樣編號
  fc150_30: string;        // 品牌名稱
  fc150_31: string;        // 公司可提供品質
  fc150_32: string;        // 來樣顏色
  fc150_33: string | null; // 建立日期
  fc150_34: number;        // 厚度
  fc150_35: boolean;       // 旗標
  fc150_36: string;        // 備註36
  fc150_80: string;        // 狀態
  fc150_91: string;        // 修改人員
  fc150_92: string | null; // 修改時間
  fc150_93: string;        // 建立人員
  fc150_191: number;       // 碼重-布重
  fc150_192: number;       // 米平方重-布重
  fc150_201: number;       // 碼重值
  fc150_202: number;       // 米平方重值
  details?: FC151[];
}

export interface CreateRequest {
  master: Omit<FC150, 'details'>;
  details: FC151[];
}

export interface UpdateRequest {
  master: Omit<FC150, 'details'>;
  details: FC151[];
}

export interface ListResponse {
  data: FC150[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Client
// ============================================================

export const c208Api = {
  list(page = 1, pageSize = 20): Promise<ListResponse> {
    return apiClient
      .get('/api/c208', { params: { page, pageSize } })
      .then((r) => r.data);
  },

  get(id: string): Promise<FC150> {
    return apiClient.get(`/api/c208/${id}`).then((r) => r.data);
  },

  create(req: CreateRequest): Promise<FC150> {
    return apiClient.post('/api/c208', req).then((r) => r.data);
  },

  update(id: string, req: UpdateRequest): Promise<FC150> {
    return apiClient.put(`/api/c208/${id}`, req).then((r) => r.data);
  },

  delete(id: string): Promise<void> {
    return apiClient.delete(`/api/c208/${id}`).then(() => undefined);
  },
};
